export default {"src":"/_next/static/media/python_logo_bd240427e1.680a753f.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};